<template>
  <nav>
    <v-toolbar elevation="2" height="70">
      <v-container class="py-0 d-flex justify-center nav-container">
        <v-toolbar-title class="d-flex">
          <v-img class="logo-img" :src="require('@/assets/img/logo.png')" alt="logo" />
          <div class="ml-3">
            <div class="subtitle-2 font-weight-bold">SMK Raden Umar Said</div>
            <div class="caption font-weight-light">Jalan Sukun Raya 9, Besito, Gebog, Kudus</div>
          </div>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items v-if="!hasLogin" class="toolbar-item">
          <v-btn
            v-for="link in links.beforeLogin"
            :key="link.text"
            small
            text
            :to="link.to"
            class="font-weight-medium mr-5"
          >{{ link.text }}</v-btn>
        </v-toolbar-items>

        <v-toolbar-items v-if="hasLogin" class="toolbar-item">
          <v-btn
            v-for="link in links.afterLogin"
            :key="link.text"
            small
            text
            :to="link.to"
            class="font-weight-medium"
          >{{ link.text }}</v-btn>
        </v-toolbar-items>
        <v-app-bar-nav-icon class="appbar-icon" @click="drawer = !drawer"></v-app-bar-nav-icon>
      </v-container>
    </v-toolbar>

    <v-navigation-drawer app v-model="drawer" temporary right disable-resize-watcher>
      <v-list dense v-if="!hasLogin">
        <v-list-item link v-for="link in links.beforeLogin" :key="link.text">
          <v-list-item-content>
            <v-btn small text :to="link.to" class="font-weight-medium">{{ link.text }}</v-btn>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list dense v-if="hasLogin">
        <v-list-item link v-for="link in links.afterLogin" :key="link.text">
          <v-list-item-content>
            <v-btn small text :to="link.to" class="font-weight-medium">{{ link.text }}</v-btn>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>


<script>
import { EventBus } from "../event-bus";

export default {
  name: "NavBar",
  data: () => ({
    links: {
      beforeLogin: [
        { to: "/", text: "Beranda" },
        { to: "/informasi", text: "Informasi" },
        { to: "/masuk", text: "Masuk" },
        { to: "/daftar", text: "Daftar" }
      ],
      afterLogin: [
        { to: "/", text: "Beranda" },
        { to: "/informasi", text: "Informasi" },
        { to: "/berkas", text: "Berkas" },
        { to: "/cetak-data", text: "Cetak Data" },
        { to: "/kotak-masuk", text: "Kotak Masuk" },
        { to: "/profil-saya", text: "Profil Saya" }
      ]
    },
    drawer: false,
    hasLogin: ""
  }),
  methods: {
    checkLoginToken() {
      if (localStorage.getItem("id")) return (this.hasLogin = true);
      else return (this.hasLogin = false);
    }
  },
  mounted() {
    this.checkLoginToken();

    EventBus.$on("triggerCheckLoginToken", () => this.checkLoginToken());
  }
};
</script>


<style scoped>
.logo-img {
  width: 42px;
}

.v-btn:before {
  background-color: transparent;
}

.v-btn {
  text-transform: unset !important;
  font-size: 0.85rem!important;
}

.underline {
  width: 1rem;
  border-bottom: 0.1rem solid #2a429e!important;
}

.v-btn--active,
.v-btn:hover {
  color: #2a429e !important;
}

.appbar-icon {
  display: none;
}

@media screen and (max-width: 900px) {
  .logo-img {
    height: 42px;
    width: 42px;
  }

  .toolbar-item {
    display: none;
  }

  .appbar-icon {
    display: initial;
  }
}
</style>

